var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { PlatformType } from '../../const/alertsConfig';
import alertsTriggerAnalyticsEvent, { analyticsHelper } from '../../helpers/analyticsMiddleware';
import getErrorBodyText from '../../helpers/getErrorBodyText';
import SyfStorage from '../../helpers/SyfStorage';
import { getAlertsData } from '../../redux/selectors';
import ErrorInfoWrapper from '../../ui/atoms/ErrorInfoWrapper';
import { useAlerts } from '../../ui/customHooks';
import getErrorCode from './getErrorCode';
import { AlertsErrorWrapper } from './subcomponents';
var ErrorPage = function (_a) {
    var analyticsAccountInfoMessage = _a.analyticsAccountInfoMessage, clientId = _a.clientId, hasConsentBanner = _a.hasConsentBanner, isPageLoaded = _a.isPageLoaded;
    var t = useTranslation().t;
    var _b = useSelector(getAlertsData, shallowEqual), alertsErrorCode = _b.error, termsConsentError = _b.termsConsentError;
    var _c = useAlerts(), platform = _c.appConfig.platform, tokenErrorCode = _c.errorCode;
    var errorCode = getErrorCode(tokenErrorCode, alertsErrorCode, termsConsentError);
    var currentLanguage = "us|".concat(SyfStorage.getLanguage());
    var errorTitle = t('errorPage.title');
    var errorMessage = platform === PlatformType.DIGITAL_SERVICING
        ? "".concat(getErrorBodyText(errorCode), " ").concat(t('errorPage.unregisteredHint'))
        : "".concat(getErrorBodyText(errorCode));
    var errorBody = platform === PlatformType.DIGITAL_SERVICING ? (_jsxs(_Fragment, { children: [getErrorBodyText(errorCode), _jsx("br", {}), t('errorPage.unregisteredHint')] })) : (_jsx(_Fragment, { children: getErrorBodyText(errorCode) }));
    useEffect(function () {
        if (isPageLoaded) {
            var _a = analyticsHelper.pageEvents.ERROR, PAGE_FUNCTION = _a.PAGE_FUNCTION, NAME = _a.NAME, PAGE_KIND = _a.PAGE_KIND;
            var siteIdentifier = analyticsHelper.siteIdentifier[platform];
            var pnl = analyticsHelper.pnl[platform];
            alertsTriggerAnalyticsEvent({
                clientName: clientId,
                message: analyticsAccountInfoMessage,
                countryLanguage: currentLanguage,
                token: SyfStorage.getCorrelationId(),
                pageFunction: PAGE_FUNCTION,
                pageName: NAME,
                pageKind: PAGE_KIND,
                pageSubFunction: errorCode,
                errorMessage: errorMessage,
                siteIdentifier: siteIdentifier,
                pnl: pnl,
                previouslyVisited: ''
            });
        }
    }, [
        errorCode,
        platform,
        errorMessage,
        currentLanguage,
        analyticsAccountInfoMessage,
        isPageLoaded,
        clientId
    ]);
    return !hasConsentBanner ? (_jsx(AlertsErrorWrapper, __assign({ "data-test": "AlertsError" }, { children: _jsx(ErrorInfoWrapper, { errorBody: errorBody, errorTitle: errorTitle }) }))) : (_jsx(ErrorInfoWrapper, { errorBody: errorBody, errorTitle: errorTitle }));
};
export default ErrorPage;
